module.exports = __webpack_public_path__ + "img/wave-2.c0b6eb46.svg";